var React = require('react');

function NavIconsApplicationsOverview (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m19.13 19.13a10.08 10.08 0 1 1 0-14.26 10.1 10.1 0 0 1 0 14.26zm-13.5-13.5a9 9 0 1 0 12.73 0 9 9 0 0 0 -12.73 0z","key":0}),React.createElement("path",{"d":"m6.43 15.06v-6.77l5.57-2.48 5.6 2.49v6.77l-5.6 2.57zm6-4v5.45l4.26-2v-5.32zm-5.11 3.42 4.25 2v-5.48l-4.25-1.82zm.79-5.94 3.89 1.7 1.47-.63-3.87-1.74zm2.54-1.15 4 1.74 1.33-.58-3.98-1.77zm3.35 4.3 1.11-.47v1l-1.11.48z","key":1})]);
}

NavIconsApplicationsOverview.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsApplicationsOverview;

NavIconsApplicationsOverview.default = NavIconsApplicationsOverview;
